// Kitchen flow pilot (Batch 5): every "Restock" / "Record a purchase" entry
// point on Store Inventory (the item row, its menu, the item drawer, Alerts)
// records the buy through the one "Already bought" dialog, started with the
// item — till / petty cash / buyer / company, store or kitchen, bill photos.
// With the flag off the dashboard keeps QuickPurchaseDialog.
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import type { StockItem, Supplier } from '@/types'
import { AlreadyBoughtDialog } from './AlreadyBoughtDialog'
import { startingCost } from './purchasingPilotLogic'

export function RestockBoughtDialog({ item, onClose, showToast }: {
  item: StockItem | null
  onClose: () => void
  showToast: (type: 'success' | 'error', message: string) => void
}) {
  const { data: supRes } = useQuery({ queryKey: ['suppliers'], queryFn: () => apiClient.listSuppliers(), enabled: !!item })
  const suppliers: Supplier[] = supRes?.data ?? []
  return (
    <AlreadyBoughtDialog
      open={!!item}
      onOpenChange={(o) => { if (!o) onClose() }}
      suppliers={suppliers}
      showToast={showToast}
      startItem={item ? {
        id: item.id, name: item.name, unit: item.unit,
        tracks_expiry: item.tracks_expiry, shelf_life_days: item.shelf_life_days,
        unit_cost: startingCost({ wac: item.wac_unit_cost, defaultCost: item.default_unit_cost }) ?? null,
      } : null}
    />
  )
}
